import React from 'react';
const Settings: React.FC = () => <div>Settings</div>;
export default Settings;